import cn from 'bem-cn';
import { Avatar, Cut, List, Stack, Tag } from '../../UI';
import { getCatagoryLink } from '../../../utils/getCategoryLink';

import { PromptInfoHeaderProps } from './PromptInfoHeader.types';
import './PromptInfoHeader.scss';

const b = cn('prompt-info-header');

const extractTagKey = (item: string) => `category-${item}`;

export const PromptInfoHeader = (props: PromptInfoHeaderProps) => {
    const { image, title, description, categories, clickableCategories = true } = props;

    const renderTag = (item: string) => (
        <Tag text={item} link={clickableCategories ? getCatagoryLink(item) : undefined} />
    );

    return (
        <Stack className={b()}>
            {image && (
                <Stack alignItems="center" className={b('image-container')}>
                    <Avatar image={image} size="large" />
                </Stack>
            )}
            <Stack spacing={8}>
                <List
                    direction="row"
                    justifyContent="center"
                    className={b('categories')}
                    items={categories}
                    renderItem={renderTag}
                    keyExtractor={extractTagKey}
                />
                <h1>{title}</h1>
                {description && <Cut maxLines={4}>{description}</Cut>}
            </Stack>
        </Stack>
    );
};
